import { TIME_BETWEEN_START_AND_END } from "./config"

type InputValue = string | number | null

export const Snippet = {
  MANDATORY: "AutoShutdown.scheduleSession.mandatory",
  START_TIME_VALIDATION: "AutoShutdown.scheduleSession.startTimeValidation",
  END_TIME_VALIDATION: "AutoShutdown.scheduleSession.endTimeValidation"
}

export const startTimeScheduleRule = (inputValue: InputValue): true | string => {
  if (!isValidCondition(inputValue)) {
    return Snippet.MANDATORY
  } else {
    const time = parseInt(inputValue as string)
    const minTimeGap = Date.now() + TIME_BETWEEN_START_AND_END

    if (time < minTimeGap) {
      return Snippet.START_TIME_VALIDATION
    }
  }

  return true
}

export const endTimeScheduleRule = (inputValue: InputValue, startTime: number | null): true | string => {
  if (!isValidCondition(inputValue) || !isValidCondition(startTime)) {
    return Snippet.MANDATORY
  } else {
    const endTime = parseInt(inputValue as string)

    if (endTime <= (startTime as number)) {
      return Snippet.END_TIME_VALIDATION
    }
  }

  return true
}

const isValidCondition = (inputValue: InputValue): boolean => {
  if (!inputValue) {
    return false
  } else {
    return isNaN(parseInt(inputValue.toString())) === false
  }
}
